var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.25 5.51465H8.25C7.18913 5.51465 6.17172 5.93608 5.42157 6.68622C4.67143 7.43637 4.25 8.45378 4.25 9.51465V13.5146C4.25421 14.2127 4.44104 14.8975 4.7919 15.501C5.14276 16.1045 5.64545 16.6056 6.25 16.9546V37.5146C6.25 38.5755 6.67143 39.5929 7.42157 40.3431C8.17172 41.0932 9.18913 41.5146 10.25 41.5146H38.25C39.3109 41.5146 40.3283 41.0932 41.0784 40.3431C41.8286 39.5929 42.25 38.5755 42.25 37.5146V16.9546C42.8546 16.6056 43.3572 16.1045 43.7081 15.501C44.059 14.8975 44.2458 14.2127 44.25 13.5146V9.51465C44.25 8.45378 43.8286 7.43637 43.0784 6.68622C42.3283 5.93608 41.3109 5.51465 40.25 5.51465ZM8.25 9.51465H40.25V13.5146H8.25V9.51465ZM10.25 37.5146V17.5146H38.25V37.5146H10.25Z",
    fill: "#292829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 21.5146H32.25V25.5146H16.25V21.5146Z",
    fill: "#292829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.d5b34b9a63f9e7607238d371e3a4015b.svg";
export { ForwardRef as ReactComponent };